import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { theme } from '../../..';
import { IconProps, DEFAULT_IMAGE_SIZE } from '../icon';
import IconSvg from '../IconSvg';

const MapsMarkerCross = (props: IconProps) => {
  const [t] = useTranslation();
  const {
    id,
    color = theme.palette.color8.hex,
    description,
    dmId = 'dm-maps-marker-cross',
    pointerEvents = 'none',
    secondColor = theme.palette.color5.hex,
    size = DEFAULT_IMAGE_SIZE,
    title = t('ds.icon.mapsMarkerCross.title'),
    ...otherProps
  } = props; // we also need to define unused props because of otherProps

  return (
    <IconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      {...otherProps}>
      <path
        fill={color}
        d="m11.99476 2a7.6186 7.6186 0 0 0 -7.77254 7.41065c0 5.21046 5.24463 10.65094 6.797 12.20108a1.43277 1.43277 0 0 0 1.96148 0c1.59437-1.55014 6.797-7.00062 6.797-12.20108a7.61918 7.61918 0 0 0 -7.78294-7.41065z"
      />
      <path
        fill={secondColor}
        d="m13.17334 10.87061 1.69189-1.6919a.74992.74992 0 1 0 -1.06054-1.06055l-1.6919 1.6919-1.69189-1.6919a.74992.74992 0 1 0 -1.06055 1.06055l1.6919 1.6919-1.6919 1.69189a.74992.74992 0 1 0 1.06055 1.06055l1.69189-1.6919 1.6919 1.6919a.74992.74992 0 1 0 1.06054-1.06055z"
      />
    </IconSvg>
  );
};

export default memo(MapsMarkerCross);
